import { pathJoin } from 'src/reducers/routing/utils'

export const createCustomerCreateRouteMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  'general-information': pathJoin(prefix)('general-information').chain,
  invoices: pathJoin(prefix)('invoices').chain,
  users: pathJoin(prefix)('users').chain,
  projects: pathJoin(prefix)('projects').chain,
})
